'use client';

import { useState } from 'react';

import Image from 'next/image';

import { Dealer } from '@gds/Icons/Paths/Dealer';

import styles from './DealerLogo.module.css';

const DealerLogo = ({ logo, name }: { logo?: string; name: string }) => {
  const [hasError, setHasError] = useState(false);

  const onImgError = () => setHasError(true);

  const renderLogo = () => {
    if (!logo || hasError) {
      return <Dealer color="primary" />;
    }

    return (
      <Image
        fill={true}
        src={logo}
        alt={name}
        onError={onImgError}
        style={hasError ? { display: 'none' } : {}}
        sizes="(max-width: 768px) 100px, 150px"
      />
    );
  };

  return (
    <span className={`${styles.bubble} ${!logo || hasError ? styles.noImage : ''}`}>
      {renderLogo()}
    </span>
  );
};
export { DealerLogo };
